/* eslint-disable react/jsx-indent */
/* eslint-disable indent */
import React from "react";
import { object, string, func, number, oneOfType, bool } from "prop-types";
import {
  Col,
  Form,
  FormLabel,
  FormControl,
  FormGroup,
  Row,
  Card,
  Alert,
} from "react-bootstrap";
import "!style-loader!css-loader!./styles.css";
import {
  getStateOptions,
  countryOptions,
  getFormattedPrice,
  BILLING_INFO_INPUT_REQUIREMENTS_LIBRARY,
} from "utils/shared";
import warning from "resources/images/warning-dark-red.png";
import { getHeaderText } from "./helperFunctions";
import OrderSummaryColumn from "./OrderSummaryColumn";

export class OrderPage extends React.PureComponent {
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.stateError &&
      nextProps.stateError !== this.props.stateError
    ) {
      const el = document.getElementById("addressState");
      const form = document.getElementById("order-page-form");

      form.classList.remove("was-validated");
      el.classList.add("is-invalid");
    }
  }

  render() {
    const {
      billingInfo,
      orderPageValidated,
      companyName,
      firstName,
      lastName,
      emailAddress,
      jobTitle,
      addressStreet,
      addressCity,
      addressState,
      addressZip,
      addressCountry,
      telephoneNumber,
      contractPrice,
      fullUpgradePrice,
      pricing,
      handleInput,
      handleProceedToPaymentButton,
      callLocation,
      paymentInformationError,
      updateOrderPageValidation,
      stateError,
      billingInfoFromInvoicePage,
      taxAmount,
      isAU,
      isAUSubsidiary,
      showAutoRenewalErrorMessage,
      showOrderDescription,
      showRingFencing,
      showParameter,
      currencyCode,
      platformInstance,
    } = this.props;

    let contractPriceToUse = contractPrice;
    if (
      !contractPrice &&
      billingInfoFromInvoicePage &&
      Object.keys(billingInfoFromInvoicePage).length > 0
    ) {
      contractPriceToUse = billingInfoFromInvoicePage.contractPrice;
    }

    const allowPaymentPlan =
      billingInfo.get("allowPaymentPlan") === 1 ||
      (billingInfoFromInvoicePage &&
        billingInfoFromInvoicePage.allowPaymentPlan === 1);

    // change the price to show in Subscription Price if payment plan is on
    const paymentPlanPrice = allowPaymentPlan
      ? (contractPriceToUse / 3).toFixed(2)
      : 0;

    const formattedPaymentPlanPrice = getFormattedPrice(paymentPlanPrice);

    // this number is used to calculate the total payment due.
    let paymentAmount = !allowPaymentPlan
      ? contractPriceToUse
      : paymentPlanPrice;
    if (
      !paymentAmount &&
      billingInfoFromInvoicePage &&
      Object.keys(billingInfoFromInvoicePage).length > 0
    ) {
      paymentAmount = billingInfoFromInvoicePage.contractPrice;
    }

    const formattedContractPrice = getFormattedPrice(contractPriceToUse);

    const taxAmountConsideringPaymentPlan = !allowPaymentPlan
      ? taxAmount
      : (taxAmount / 3).toFixed(2);

    const formattedTaxAmount = getFormattedPrice(
      taxAmountConsideringPaymentPlan
    );

    const formattedTotalAmount = getFormattedPrice(
      Number(paymentAmount) + Number(taxAmountConsideringPaymentPlan)
    );

    const taxAmountToShow =
      isAUSubsidiary || billingInfoFromInvoicePage
        ? formattedTaxAmount
        : "Calculated on next screen";

    let formattedFullPrice;
    if (["zipRecruiterUpgrade", "orderPage"].includes(callLocation)) {
      formattedFullPrice = getFormattedPrice(fullUpgradePrice);
    } else if (pricing) {
      formattedFullPrice = getFormattedPrice(pricing.get("fullPrice"));
    } else {
      formattedFullPrice = getFormattedPrice(fullUpgradePrice);
    }

    const handleProceedToPaymentButtonClick = (e) => {
      e.preventDefault();
      const form = e.currentTarget;
      if (form.checkValidity() === false) {
        e.stopPropagation();
        updateOrderPageValidation(true);
      } else {
        handleProceedToPaymentButton();
      }
    };

    const getHeaderComponent = () => {
      if (showAutoRenewalErrorMessage) {
        return (
          <Alert variant="danger" className="d-flex">
            <div>
              <img
                className="mr-3"
                width="16px"
                src={warning}
                alt="caution sign"
              />
            </div>
            <div>
              Your subscription is currently on hold due to a payment issue.
              Please review your billing and credit card details to resume your
              subscription immediately. If this is incorrect, please reach out
              to your Account Manager.
            </div>
          </Alert>
        );
      }

      if (billingInfo.size > 0 && billingInfo.get("freeTrial")) {
        return (
          <div>
            <p>
              Invest in smarter talent decisions with Criteria’s proven science
              and seamless experience. Complete the form below to start
              optimizing your process today.
            </p>
            <hr />
          </div>
        );
      }

      return (
        <div>
          <p>{getHeaderText(callLocation)}</p>
          <hr />
        </div>
      );
    };

    const countriesRequiredState =
      BILLING_INFO_INPUT_REQUIREMENTS_LIBRARY.state;

    return (
      <Form
        noValidate
        validated={orderPageValidated}
        onSubmit={handleProceedToPaymentButtonClick}
        id="order-page-form"
      >
        <div className="order-form-wrapper">
          <div className="form-column">
            <Card className="p-4">
              <Card.Body className="p-0">
                {getHeaderComponent()}
                <Row>
                  <Col lg={12} md={12} sm={12} xs={12}>
                    <h4 className="mb-3">Billing Information</h4>
                  </Col>
                </Row>
                <Row>
                  <Col lg={12} md={12} sm={12} xs={12}>
                    <FormGroup>
                      <FormLabel>Company Name</FormLabel>
                      <FormControl
                        type="text"
                        id="companyName"
                        value={companyName}
                        onChange={handleInput}
                        required
                      />
                      <Form.Control.Feedback type="invalid">
                        Please enter a Company Name.
                      </Form.Control.Feedback>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col lg={4} md={4} sm={4} xs={4}>
                    <FormGroup>
                      <FormLabel>First Name</FormLabel>
                      <FormControl
                        type="text"
                        id="firstName"
                        value={firstName}
                        onChange={handleInput}
                        required
                      />
                      <Form.Control.Feedback type="invalid">
                        Please enter a First Name.
                      </Form.Control.Feedback>
                    </FormGroup>
                  </Col>
                  <Col lg={4} md={4} sm={4} xs={4}>
                    <FormGroup>
                      <FormLabel>Last Name</FormLabel>
                      <FormControl
                        type="text"
                        id="lastName"
                        value={lastName}
                        onChange={handleInput}
                        required
                      />
                      <Form.Control.Feedback type="invalid">
                        Please enter a Last Name.
                      </Form.Control.Feedback>
                    </FormGroup>
                  </Col>
                  <Col lg={4} md={4} sm={4} xs={4}>
                    <FormGroup>
                      <FormLabel>Job Title</FormLabel>
                      <FormControl
                        type="text"
                        id="jobTitle"
                        value={jobTitle}
                        onChange={handleInput}
                        required
                      />
                      <Form.Control.Feedback type="invalid">
                        Please enter a Job Title.
                      </Form.Control.Feedback>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col lg={6} md={6} sm={6} xs={6}>
                    <FormGroup>
                      <FormLabel>Email Address</FormLabel>
                      <FormControl
                        type="text"
                        id="emailAddress"
                        value={emailAddress}
                        onChange={handleInput}
                        required
                      />
                      <Form.Control.Feedback type="invalid">
                        Please enter an Email Address.
                      </Form.Control.Feedback>
                    </FormGroup>
                  </Col>
                  <Col lg={6} md={6} sm={6} xs={6}>
                    <FormGroup>
                      <FormLabel>Telephone Number</FormLabel>
                      <FormControl
                        type="tel"
                        pattern="^[0-9-+\s()]*$"
                        id="telephoneNumber"
                        value={telephoneNumber}
                        onChange={handleInput}
                        required
                      />
                      <Form.Control.Feedback type="invalid">
                        Please enter a Telephone Number.
                      </Form.Control.Feedback>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col lg={12} md={12} sm={12} xs={12}>
                    <FormGroup>
                      <FormLabel>Street Address</FormLabel>
                      <FormControl
                        type="text"
                        id="addressStreet"
                        value={addressStreet}
                        onChange={handleInput}
                        required
                        maxLength={60}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please enter a Street Address.
                      </Form.Control.Feedback>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col lg={6} md={6} sm={6} xs={6}>
                    <FormGroup>
                      <FormLabel>City</FormLabel>
                      <FormControl
                        type="text"
                        id="addressCity"
                        value={addressCity}
                        onChange={handleInput}
                        required
                      />
                      <Form.Control.Feedback type="invalid">
                        Please enter a City.
                      </Form.Control.Feedback>
                    </FormGroup>
                  </Col>
                  <Col lg={3} md={3} sm={3} xs={6}>
                    <FormGroup>
                      <FormLabel>State</FormLabel>
                      <FormControl
                        as="select"
                        placeholder="state"
                        id="addressState"
                        value={addressState}
                        onChange={handleInput}
                        disabled={
                          ![...countriesRequiredState, "CA", ""].includes(
                            addressCountry
                          )
                        }
                        required={countriesRequiredState.includes(
                          addressCountry
                        )}
                      >
                        {getStateOptions(addressCountry)}
                      </FormControl>
                      <Form.Control.Feedback type="invalid">
                        {stateError}
                      </Form.Control.Feedback>
                    </FormGroup>
                  </Col>
                  <Col lg={3} md={3} sm={3} xs={6}>
                    <FormGroup>
                      <FormLabel>Zip</FormLabel>
                      <FormControl
                        type="text"
                        id="addressZip"
                        value={addressZip}
                        onChange={handleInput}
                        required={BILLING_INFO_INPUT_REQUIREMENTS_LIBRARY.zipCode.includes(
                          addressCountry
                        )}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please enter a {isAU ? "Zip / Post Code" : "Zip Code"}.
                      </Form.Control.Feedback>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col lg={12} md={12} sm={12} xs={12}>
                    <FormGroup>
                      <FormLabel>Country</FormLabel>
                      <FormControl
                        as="select"
                        id="addressCountry"
                        value={addressCountry}
                        onChange={handleInput}
                        required
                      >
                        {countryOptions}
                      </FormControl>
                      <Form.Control.Feedback type="invalid">
                        Please enter a Country.
                      </Form.Control.Feedback>
                    </FormGroup>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </div>
          <div className="order-summary-column">
            <Card className="p-4">
              <OrderSummaryColumn
                allowPaymentPlan={allowPaymentPlan}
                buttonText="Continue to Payment Details"
                callLocation={callLocation}
                formattedContractPrice={formattedContractPrice}
                formattedFullPrice={formattedFullPrice}
                formattedPaymentPlanPrice={formattedPaymentPlanPrice}
                formattedTotalAmount={formattedTotalAmount}
                isAUSubsidiary={isAUSubsidiary}
                paymentInformationError={paymentInformationError}
                pricing={pricing}
                taxAmountToShow={taxAmountToShow}
                showOrderDescription={showOrderDescription}
                showRingFencing={showRingFencing}
                showParameter={showParameter}
                currencyCode={currencyCode}
                platformInstance={platformInstance}
              />
            </Card>
          </div>
        </div>
      </Form>
    );
  }
}

OrderPage.propTypes = {
  billingInfo: object.isRequired,
  orderPageValidated: bool.isRequired,
  companyName: string,
  firstName: string,
  lastName: string,
  emailAddress: string,
  addressStreet: string,
  addressCity: string,
  addressState: string,
  addressZip: string,
  addressCountry: string,
  telephoneNumber: string,
  jobTitle: string,
  pricing: object,
  callLocation: string,
  contractPrice: oneOfType([string, number]),
  fullUpgradePrice: oneOfType([string, number]),
  handleInput: func.isRequired,
  handleProceedToPaymentButton: func.isRequired,
  paymentInformationError: bool.isRequired,
  updateOrderPageValidation: func.isRequired,
  stateError: string.isRequired,
  billingInfoFromInvoicePage: object,
  taxAmount: oneOfType([string, number]),
  isAU: bool,
  isAUSubsidiary: bool,
  showAutoRenewalErrorMessage: bool,
  showOrderDescription: bool,
  showRingFencing: bool,
  showParameter: bool,
  currencyCode: string,
  platformInstance: string,
};

export default OrderPage;
